import React from 'react';

/** A full-size card shrunk to a box, for pickers and previews. */
export default function ScaledCard({ box, width = 1080, height = 1920, children }) {
  const s = Math.min(box / width, box / height);
  return (
    <span aria-hidden style={{ position: 'absolute', left: (box - width * s) / 2, top: (box - height * s) / 2, width, height, transform: `scale(${s})`, transformOrigin: 'top left', pointerEvents: 'none' }}>
      {children}
    </span>
  );
}
